/**
 * Resolves the API base URL.
 *
 * Allows keeping both variables in `.env`:
 *   VITE_API_URL       = 'https://api-app.showphaze.com/api'   (default/prod)
 *   VITE_API_URL_LOCAL = 'http://localhost:8000/api'           (local dev)
 *
 * When running in dev (`import.meta.env.DEV === true`) and `VITE_API_URL_LOCAL`
 * is set, that one is used. Otherwise it falls back to `VITE_API_URL`. The final
 * `/api` fallback covers the SSR / build-without-env scenario (generally impossible).
 *
 * This avoids having to manually edit `.env` every time the developer wants to
 * point at the local backend instead of the remote one.
 */
export function resolveApiBaseUrl(): string {
  const env = (import.meta as any).env ?? {};
  const isDev = env?.DEV === true || env?.MODE === "development";
  const local = env?.VITE_API_URL_LOCAL as string | undefined;
  const remote = env?.VITE_API_URL as string | undefined;
  if (isDev && local && local.trim()) return local.trim();
  if (remote && remote.trim()) return remote.trim();
  return "/api";
}

/** Cached singleton — computed once per bundle. */
export const API_BASE_URL = resolveApiBaseUrl();
